/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The helper to form query params string
 *
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.2.0
 */

export const formQueryParamsString = (params: {[key: string]: string | number}): string => {
    return '?' + Object.keys(params)
        .reduce((query: string[], key: string) => {
            if (params[key] !== '') query.push(`${key}=${params[key]}`);
            return query;
        },[])
        .join('&');
};
